
export async function swUnregisterHelper(navigator){
  if ('serviceWorker' in navigator) {
    const registrations = await navigator.serviceWorker.getRegistrations();
    for (let registration of registrations) {
      await registration.unregister();
      this.log("Service Worker entfernt");
    }
  }
}

